import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";

import "intersection-observer";
import "core-js/modules/es.array.iterator";

import "@wikicasa/common/select";

import Siema from "@wikicasa/common/carousel";
import * as Common from "@wikicasa/common/common";
import * as Pagination from "@wikicasa/common/pagination";
import type {LatLng, Marker, LeafletEvent} from "leaflet";
import {IInsertion} from "@wikicasa/common/pagination";
import type LeafletMap from "@wikicasa/common/leaflet_map";
import "../../style/vendor/leafleft.theme.scss";
import {COLORS, MAP_TILER_APIKEY} from "./variables";
import {
    EMAIL_REGEX_INTO_TEXT,
    PHONE_REGEX,
    DATE_REGEX,
    EXCLUDED_REGEX,
    COMPETITOR_REGEX
} from "@wikicasa/common/common";

let $list: JQuery;
let $mapCarousel: JQuery;

let LeafletMapModule: any;
let Contact: any;

let map: LeafletMap;

export const page: Array<IInsertion> = [];

interface IListingInit {
    click?: boolean;
    list?: string;
    getMapMarkers?: () => JQueryPromise<any> | undefined;
    buildInfoWindow?: (ids: number | Array<number>) => Promise<string>;
}

declare global {
    interface Window {
        _count: number;
        _pageSize: number;
        _currentPage: number;
        _serializedSearchBean: string;
    }
}

let ListingInit = {click: true} as IListingInit;

export function init(opts: IListingInit): void {

    if (opts)
        ListingInit = $.extend({}, ListingInit, opts);

    $list = $(ListingInit.list || "");

    const $mapTabBtn = $("#tab-map-btn");
    const $listTabBtn = $("#tab-list-btn");

    Common.observe(".siema", (elem: Element) => {
        new Siema({
            selector: elem,
            loop: true,
            onInit: function (): void {
                this.lazyLoad();
                this.addArrows();
            }
        });
    });

    if (ListingInit.click) {
        $(document).on("click", ".insertion, .media", function (e: JQuery.TriggeredEvent) {

            const url = $(this).data("url");

            if (!url)
                return;

            if ($(e.target).parents(".favorite-button-container").length ||
                $(e.target).parents(".fav-note").length ||
                $(e.target).parents(".fav").length ||
                $(e.target).parents(".media-buttons").length)
                return;

            if (e.metaKey || $(this).data("target") === "_blank")
                window.open(url, "_blank");
            else
                location.href = url;
        });

        $(document).on("click", ".title-link", (e: JQuery.Event) => {
            e.preventDefault();
        });
    }

    const $insertions = $list.find(".insertion");

    for (let i = 0; i < $insertions.length; i++) {
        const $card = $($insertions[i]);

        const url = $card.data("url");
        const id = $card.data("id");
        const agencyId = $card.data("agency-id");

        page.push({
            id: id,
            agencyId: agencyId,
            url: url
        } as IInsertion);

        const $description = $card.find(".description");

        let text = $description.text().trim();

        text = text.replace(EMAIL_REGEX_INTO_TEXT, "***");
        text = text.replace(COMPETITOR_REGEX, "***");
        text = text.replace(PHONE_REGEX, (match: string, p1: never, p2: never, p3: never, offset: number) => {

            if (p1) return match;
            if (match.match(DATE_REGEX))
                return match;

            const start = Math.max(0, offset - 6);
            const tmp = text.substring(start, offset).toLowerCase();
            return EXCLUDED_REGEX.some((s: string) => tmp.indexOf(s.toLowerCase()) > -1) ? match : "***";
        });

        $description.text(text);
    }

    $("#request-modal").on("show.bs.modal", (e: JQuery.EventBase) => {

        const data = $(e.relatedTarget || "").data("data");

        $("#request-modal-body").toggle(!data.externalURL);
        $("#request-modal-body-externalURL").toggle(!!data.externalURL);
        $("#request-modal-body-externalURL a").attr("href", data.externalURL);

        import(/* webpackChunkName: "chunks/contact" */ "./contact").then((module: any) => {

            if (!Contact) {
                Contact = module;
                Contact.init();
            }

            Contact.showDialogContact(data);
        });

    });

    $("#searchBox").on("show.bs.collapse", function () {

        if ($("#listing-header").hasClass("js-is-sticky")) {

            const headerOffset = $("#header").offset();

            if (headerOffset)
                $("html, body").animate({
                    scrollTop: headerOffset.top
                }, 500);


        }
    });

    $("#navigation").on("click", "a[href]", "[data-href]", function (e: JQuery.Event) {
        e.preventDefault();
        e.stopPropagation();

        const URL = this.getAttribute("data-href") ?? this.getAttribute("href");

        // Niccolò: if search is not empty, force param page to 1 when change place
        if (window.location.search)
            window.location.href = URL + Common.setParam("p", "1", window.location.search);
        else
            window.location.href = URL;

    });

    $("#place-select").change(function () {

        const self = this as HTMLInputElement;

        if (self.value)
            window.location.href = self.value;
    });

    // Andrea M: trigger resize to fix responsive carousel width change
    $listTabBtn.on("show.bs.tab", () => window.dispatchEvent(Common.createCustomEvent("resize")))
    $mapTabBtn.on("shown.bs.tab", () => window.dispatchEvent(Common.createCustomEvent("resize")))

    $listTabBtn.on("show.bs.tab", () => window.location.hash = "#list");
    $mapTabBtn.on("show.bs.tab", () => window.location.hash = "#map");

    $(window).on("popstate", () => {
        switch (window.location.hash) {
            case "#map":
                $mapTabBtn.click();
                break;
            default :
                $listTabBtn.click();
                break;
        }
    });

    $mapTabBtn.on("hidden.bs.tab", () => {
        $("#related-links").show();
        $("#footer").show();
        $("#suggestion-banner").show();
        $(".order-item").show();
        $("#save-search-mobile").hide();
    });

    $mapTabBtn.on("show.bs.tab", () => {
        $("#related-links").hide();
        $("#footer").hide();
        $("#suggestion-banner").hide();
        $(".order-item").hide();
        $("#save-search-mobile").show();
    });

    $mapTabBtn.on("shown.bs.tab", () => {

        initMap();
    });
    Common.observe("#map", () => initMap());

    initOrder();

    //stickybits("#listing-header", {
    //    useStickyClasses: true
    //});

    if (window.location.hash === "#map")
        $mapTabBtn.click();

    if (!window["_count"] || !window["_currentPage"] || !window["_pageSize"])
        return;

    const match = window.location.href.match(/(^[^#]*)/);
    const backURL = match ? match[0] : "";

    Pagination.create(window["_count"], window["_pageSize"], window["_currentPage"],
        page, window["_serializedSearchBean"], backURL);
}

function initMap(): void {

    if (map)
        return;

    const $selector = $("#map");

    let center: LatLng, limit: number, latLngs: Array<LatLng> | undefined;

    const search = Common.getSearch();

    if (search && search["polygonFromMap"]) {

        latLngs = Common.parsePoints(search["polygonFromMap"]);

        if (latLngs) {
            center = Common.calcPolygonCenter(latLngs);

            $selector.attr("data-lat", center.lat);
            $selector.attr("data-lng", center.lng);
        }
    } else if (search) {
        center = {lat: search["latitude"], lng: search["longitude"]} as LatLng;

        if (!search["cityId"])
            limit = 80000;
    }

    import(/* webpackChunkName: "chunks/leaflet_map" */ "@wikicasa/common/leaflet_map").then((module: any) => {

        // Andrea M: need to do this check due to multiple import chunks
        if (LeafletMapModule)
            return;

        LeafletMapModule = module.default;

        map = new LeafletMapModule();

        map.init($selector, MAP_TILER_APIKEY, COLORS);

        Promise.all([
            new Promise((resolve: (markers: Array<Marker>) => void) => {
                if (!ListingInit.getMapMarkers)
                    resolve([]);

                // @ts-ignore
                ListingInit.getMapMarkers().done((markers: Array<Marker>) => resolve(markers))
            }),
            new Promise((resolve: (...args: Array<unknown>) => void) => {
                map.ready(() => {
                    map.startSpinner();
                    resolve();
                })
            })
        ]).then(([first]: Array<unknown>) => {
            const markers = first === undefined ? [] : first;

            const $shapeDrawListing = $("#shape-draw-listing");
            const $shapeConfirmListing = $("#shape-confirm-listing");
            const $shapeDeleteListing = $("#shape-delete-listing");
            const $shapeCancelListing = $("#shape-cancel-listing");

            if (latLngs)
                map.drawPolygonFromPoints(latLngs);

            // @ts-ignore
            map.addMarkerBulk(markers, center, limit);

            map.stopSpinner();

            if (map.hasShape()) {
                $shapeDrawListing.show();
                $shapeDeleteListing.show();
                map.fitBounds(map.getShape().getBounds());
            } else if (map.getMarkersCount())
                map.fitBounds(map.getMarkerClusterer().getBounds());

            map.addListener(map.getMap(), "zoomend", () => {

                const options: Record<string, any> = (map.getMarkerClusterer() as any).options;

                if (options) {
                    options.zoomToBoundsOnClick = map.getZoom() < 16;
                    map.getMap().closePopup();
                }
            });

            map.addListener(map.getMarkerClusterer(), "click", (e: LeafletEvent) => {
                const marker: any = e.layer;

                map.highlightCluster(marker);

                if (ListingInit.buildInfoWindow)
                    ListingInit.buildInfoWindow([marker["id"]]).then((html: string) => drawInfowindows(html, marker.getLatLng()));
            });

            map.addListener(map.getMarkerClusterer(), "clusterclick", (e: LeafletEvent) => {

                const cluster = e.layer;
                const markers = cluster.getAllChildMarkers();
                const len = markers.length;

                map.highlightCluster(cluster);

                if (len === 1 || map.getZoom() >= 16) {

                    const ids = [];
                    for (let i = 0; i < len; i++) {
                        ids.push(markers[i].id);
                    }

                    if (ListingInit.buildInfoWindow)
                        ListingInit.buildInfoWindow(ids).then((html: string) => drawInfowindows(html, cluster.getLatLng()));
                }
            });

            map.getMap().on("draw:drawstart", () => {
                map.getMap().scrollWheelZoom.disable();
            });


            $("#tab-list").on("mouseenter", ".insertion", function () {
                const id = $(this).data("id");
                map.highlightMarker(id);

                $(this).one("mouseleave", () => {
                    map.clearHighlight();
                });
            });

            $shapeDrawListing.on("click", () => {
                $shapeDrawListing.hide();
                $shapeCancelListing.show();
                $shapeDeleteListing.hide();
                map.deleteShape();
                map.setDrawing();
            })

            $shapeConfirmListing.on("click", () => {
                map.stopDrawing();
                if (map.hasShape()) {
                    trigger("shape.confirm");
                }
            });

            $shapeCancelListing.on("click", () => {
                map.getMap().scrollWheelZoom.enable();
                $shapeCancelListing.hide();
                $shapeConfirmListing.hide();
                $shapeDrawListing.show();
                map.stopDrawing();
                map.deleteShape();

                if (latLngs) {
                    map.drawPolygonFromPoints(latLngs);
                    $shapeDeleteListing.show();
                }

                //trigger("shape.delete");
            });

            $shapeDeleteListing.on("click", () => {
                $shapeCancelListing.hide();
                $shapeDeleteListing.hide();
                map.stopDrawing();
                map.deleteShape();
                latLngs = undefined;
                trigger("shape.deleted");
            });

            map.ready(() => {
                map.getMap().on("draw:editvertex", () => {
                    $shapeDrawListing.hide();
                    $shapeConfirmListing.show();
                    $shapeDeleteListing.hide();
                    $shapeCancelListing.show();

                    if (!validateMap()) {
                        $("#map-error-listing").show();
                        $selector.addClass("map-error");
                        $shapeConfirmListing.attr("disabled", "disabled");
                    } else {
                        $("#map-error-listing").hide();
                        $selector.removeClass("map-error");
                        $shapeConfirmListing.removeAttr("disabled");
                    }
                });

                map.getMap().on("draw:created", () => {

                    map.getMap().scrollWheelZoom.enable();

                    if (map.isDrawing()) {
                        $shapeConfirmListing.show();
                        $shapeDeleteListing.show();
                    }

                    if (!validateMap()) {
                        $("#map-error-listing").show();
                        $selector.addClass("map-error");
                        $shapeConfirmListing.attr("disabled", "disabled");
                    } else {
                        $("#map-error-listing").hide();
                        $selector.removeClass("map-error");
                        $shapeConfirmListing.removeAttr("disabled");
                        $shapeDeleteListing.hide();
                    }
                });

                map.getMap().on("draw:deleted", () => {
                    $("#map-error-listing").hide();
                    $selector.removeClass("map-error");
                    $shapeDrawListing.show();
                    $shapeConfirmListing.removeAttr("disabled");
                });
            });

            map.on("click zoomstart", () => {
                map.clearHighlight();
                $mapCarousel.hide();
            });

            $mapCarousel = $(`<div id="infowindow-carousel" class="infowindow-carousel siema bg-white text-left m-0 d-sm-none"></div>`);

            $mapCarousel.insertAfter(map.getMapContainer());

            const drawInfowindows = function (html: string, position: LatLng): void {

                map.getInfowindow().setLatLng(position);
                map.getMap().openPopup(map.getInfowindow());

                $("#wrapper-single").empty();

                const infowindowMultiple = $("#wrapper-multiple");

                if ($mapCarousel.data("siema"))
                    $mapCarousel.data("siema").destroy();

                infowindowMultiple.html(html);
                $mapCarousel.html($(html).find(".media").clone() as any);
                infowindowMultiple.show();
                $mapCarousel.show();

                // @ts-ignore
                map.getInfowindow()._adjustPan();

                $mapCarousel.data("siema",
                    new Siema({
                        selector: $mapCarousel[0],
                        loop: false,
                        perPage: 1,
                        onInit: function (): void {
                            this.loadBar();
                            //this.addArrows();
                        },
                        onChange: function (): void {
                            this.updateBar();
                        }
                    }));
            }
        });
    });
}

function initOrder(): void {

    const $orderSelectors = $(".form-control-order");

    if (!$orderSelectors.length)
        return;

    const search = Common.getSearch();

    // Manually change order select menu due to prevent reloading page
    if (search && search["filterOrderId"]) {
        $orderSelectors.val(search["filterOrderId"]);
        const label = $orderSelectors.find(`option[value=${search["filterOrderId"]}]`).first().text();
        $orderSelectors.next().find("span").text(label);
    }

    $orderSelectors.change(function () {
        const $field = $(this);
        const cURL = Common.setParam("Ordinamento", $field.val() ? String($field.val()) : "");
        window.location.href = Common.updateQueryStringParameter(cURL, "p", "");

        const $modalOrder = $("#modal-order");

        $modalOrder.data("bs.modal")._config.backdrop = "static";
        $modalOrder.data("bs.modal")._config.keyboard = false;
    });
}

function validateMap(): boolean {

    const mapRange = window._mapRange || 10000;

    const center = map.getShape().getCenter();
    const points = map.getShapePoints();

    for (let i = 0; i < points.length; i++) {
        if (map.getDistance(points[i], center) > mapRange)
            return false;
    }

    return true;
}

export function trigger(event: string): void {
    $list.trigger(event);
}

export function on(event: string, fn: () => void): void {
    $list.on(event, () => fn());
}

export function getMap(): LeafletMap {
    return map;
}